import { ChangeEvent, useEffect, useState } from "react"
import useFirebaseAuth from "shared/hooks/useFirebaseAuth";
import useFirestore from "shared/hooks/useFirestore";
import { useLocation} from "react-router-dom";

interface branchInputs{
    name:string,
    tel:string,
    address:string,
    address_detail:string,
    business_num:string,
    owner_name:string,
    owner_tel:string,
    id:string,
    pw:string,
    pw_re:string
}


const useBranchRegister = () => {
    const { createAccount } = useFirebaseAuth();
    const branch_id = useLocation().state;
    const { writeFirestore, updateFirestore, readFirestoreOneDoc, deleteFirestore } = useFirestore();
    const [isError, setIsError] = useState(false);
    const [isSucceed, setIsSucced] = useState(false);
    const [isDuplicated, setIsDuplicated] = useState(null);
    const [isOpenPasswordModal, setIsOpenPasswordModal] = useState(false);
    const [isOpenDuplicatedModal, setIsOpenDuplicatedModal] = useState(false);
    const [isOpenNullModal, setIsOpenNullModal] = useState(false);
    const [isOpenDeleteSucceedModal, setIsOpenDeleteSucceedModal] = useState(false);
    const [reportPermission, setReportPermission] = useState({
        word:true,
        sentence:true,
        video:true
    })
    const [branchInputs, setBranchInputs] = useState<branchInputs>({
        name:"",
        tel:"",
        address:"",
        address_detail:"",
        business_num:"",
        owner_name:"",
        owner_tel:"",
        id:"",
        pw:"",
        pw_re:""
    })

    useEffect(() => {
        if(branch_id){
            getBranchData();
        }
        // eslint-disable-next-line
    }, [branch_id])

    const getBranchData = () => {
        readFirestoreOneDoc("User/Auth/Branch", branch_id).then(res => {
            if(res.exists()){
                const data = res.data();
                setBranchInputs({
                    id:data.id,
                    pw:data.pw,
                    pw_re:data.pw,
                    owner_tel:data.owner_tel,
                    owner_name:data.owner_name,
                    address:data.address,
                    address_detail:data.address_detail,
                    business_num:"",
                    name:data.name,
                    tel:data.tel,
                })
                setReportPermission({
                    ...data.report_permission
                })
            }
        })
    }

    const onPermissionChangeHandler = (e:ChangeEvent<HTMLInputElement>) => {
        const {name, checked} = e.target;
        setReportPermission({
            ...reportPermission,
            [name]:checked
        })
    }

    const onBranchChange = (e:ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target;
        setBranchInputs({
            ...branchInputs,
            [name]:value
        })
    }

    const onSaveButtonClick = () => {
        if(branch_id){
            updateBranch();
        }else{
            registerBranch();
        }
    }

    const updateBranch = async() =>{
        const owner_name = branchInputs.owner_name.trim();
        const owner_tel = branchInputs.owner_tel.trim();
        const tel = branchInputs.tel.trim();
        const name = branchInputs.name.trim();
        const address = branchInputs.address.trim();
        const address_detail = branchInputs.address_detail.trim();
        if(!(name)){
            setIsOpenNullModal(true);
            return;
        }
        const data = {
            name:name,
            tel:tel,
            owner_name:owner_name,
            owner_tel:owner_tel,
            report_permission:reportPermission,
            address:address,
            address_detail:address_detail
        }


        updateFirestore("User/Auth/Branch", branch_id, data).then(res =>{
            if(res){
                setIsSucced(true);
            }else{
                setIsError(true);
            }
        })
    }

    const registerBranch = async() =>{
        const owner_name = branchInputs.owner_name.trim();
        const id = branchInputs.id.trim();
        const pw = branchInputs.pw.trim();
        const pw_re = branchInputs.pw_re.trim();
        const owner_tel = branchInputs.owner_tel.trim();
        const tel = branchInputs.tel.trim();
        const name = branchInputs.name.trim();
        const address = branchInputs.address.trim();
        const address_detail = branchInputs.address_detail.trim();
        if(!(id && pw && pw_re && name && owner_name)){
            setIsOpenNullModal(true);
            return;
        }
        if(isDuplicated || isDuplicated === null){
            setIsOpenDuplicatedModal(true);
            return;
        }
        if(pw !== pw_re){
            setIsOpenPasswordModal(true);
            return;
        }
        const res = await createAccount(`${id}@toss.kr`, pw);
        if(res === null){
            setIsError(true);
            return;
        }
        const data = {
            id:id,
            pw:pw,
            owner_name:owner_name,
            owner_tel:owner_tel,
            name:name,
            tel:tel,
            report_permission:reportPermission,
            address:address,
            address_detail:address_detail,
            register_date:new Date(),
            pay_date:1
        }

        writeFirestore("User/Auth/Branch", res.uid, data).then(res => {
            if(res){
                setIsSucced(true);
            }else{
                setIsError(true);
            }
        })

        writeFirestore("User/Auth/Log", res.uid, data).then(res => {
            if(res){
               setIsSucced(true);
            }
        })

    }

    const onDeleteClickHandler = () => {
        deleteFirestore("User/Auth/Branch", branch_id).then(res => {
          if(res){
            setIsOpenDeleteSucceedModal(true);
          }
        })
    }

    return {branchInputs, onBranchChange, onSaveButtonClick, isError, setIsError, isSucceed, setIsDuplicated, 
        isOpenPasswordModal, setIsOpenPasswordModal, isOpenDuplicatedModal, setIsOpenDuplicatedModal,
        isOpenNullModal, setIsOpenNullModal, isOpenDeleteSucceedModal, setIsOpenDeleteSucceedModal, onDeleteClickHandler,
        reportPermission, onPermissionChangeHandler
    }
}

export default useBranchRegister;